import React, { useContext, useCallback, RefObject } from "react";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import Drawer from "@material-ui/core/Drawer";
import {} from "bodycodi/cmap/app/js/common";

type Props = {
  onClickAlbum?: any;
  onClickDefault?: () => void;
  inputRef: RefObject<HTMLInputElement>;
};

const ImagePickerDrawer = ({ onClickDefault, onClickAlbum, inputRef }: Props) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const setOpen = (open: boolean) => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "IMG_PICKER_DRAWER_POP",
      open: { imgPickerDrawerPop: open },
    });
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Drawer
      anchor="bottom"
      open={state.imgPickerDrawerPop}
      onClose={handleClose}
      className="picker-pop auto"
    >
      <PickerHeader title="프로필 사진 설정" onClose={handleClose} />
      <div className="img-picker-wrapper">
        <label htmlFor="upload" className="pick-button">
          <p>앨범에서 사진 선택</p>
          <input
            id="upload"
            type="file"
            accept="image/*"
            ref={inputRef}
            hidden
            onChange={(e: any) => {
              if (e.target.files[0].size === 0) return;
              onClickAlbum();
            }}
          />
        </label>
        <div className="default-button" onClick={onClickDefault}>
          기본 이미지로 변경
        </div>
      </div>
    </Drawer>
  );
};

export default ImagePickerDrawer;
